import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "app_name": "AbilityOS",
      "tagline": "Empowering Every Ability",
      "dashboard": "Dashboard",
      "super_admin": "Super Admin Control",
      "student_registry": "Student Registry",
      "iep_goals": "IEP Care Plans",
      "therapy_sessions": "Therapy Sessions",
      "aac_board": "AAC Communication Board",
      "soap_notes": "SOAP Notes",
      "save": "Save",
      "cancel": "Cancel",
      "high_contrast": "High Contrast Mode",
      "font_dyslexic": "OpenDyslexic Font"
    }
  },
  hi: {
    translation: {
      "app_name": "एबिलिटी-ओएस",
      "tagline": "हर क्षमता को सशक्त बनाना",
      "dashboard": "डैशबोर्ड",
      "super_admin": "सुपर एडमिन नियंत्रण",
      "student_registry": "छात्र रजिस्ट्रार",
      "iep_goals": "आईईपी लक्ष्य योजनाएं",
      "therapy_sessions": "थेरेपी सत्र",
      "aac_board": "एएसी संचार बोर्ड",
      "soap_notes": "एसओएपी नोट्स",
      "save": "सुरक्षित करें",
      "cancel": "रद्द करें",
      "high_contrast": "उच्च कंट्रास्ट मोड",
      "font_dyslexic": "ओपन-डिस्लेक्सिक फ़ॉन्ट"
    }
  },
  mr: {
    translation: {
      "app_name": "ॲबिलिटी-ओएस",
      "tagline": "प्रत्येक क्षमतेला सक्षम करणे",
      "dashboard": "डॅशबोर्ड",
      "super_admin": "सुपर ॲडमिन नियंत्रण",
      "student_registry": "विद्यार्थी नोंदणी",
      "iep_goals": "आयईपी उद्दिष्टे",
      "therapy_sessions": "थेरपी सत्रे",
      "aac_board": "एएसी संवाद बोर्ड",
      "soap_notes": "एसओएपी नोंदी",
      "save": "जतन करा",
      "cancel": "रद्द करा",
      "high_contrast": "उच्च कॉन्ट्रास्ट मोड",
      "font_dyslexic": "ओपन-डिस्लेक्सिक फॉन्ट"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
